/* eslint-disable sort-imports */
/* eslint-enable sort-imports: "error" */
// Imports should be alphabetized
import Vue from 'vue'
import Router from 'vue-router'
import { Message } from 'element-ui'
import apollo from '@/graphql'
import store from '@/store'
import * as log from 'loglevel'

import ChangeFrontendPage from '@/graphql/page/ChangeFrontendPage.gql'

const AdvertiserCreation = () =>
  import(/* webpackChunkName: "AdvertiserCreation" */ '@/components/advertiser/AdvertiserCreation')
const AdvertiserDetails = () =>
  import(/* webpackChunkName: "AdvertiserDetails" */ '@/components/advertiser/AdvertiserDetails')
const AdvertiserList = () =>
  import(/* webpackChunkName: "AdvertiserList" */ '@/components/advertiser/AdvertiserList')
const AuditDetails = () =>
  import(/* webpackChunkName: "AuditDetails" */ '@/components/audit/AuditDetails')
const AuditList = () => import(/* webpackChunkName: "AuditList" */ '@/components/audit/AuditList')
const AuditReview = () =>
  import(/* webpackChunkName: "AuditReview" */ '@/components/audit/review/AuditReview')
const BannerCreation = () =>
  import(/* webpackChunkName: "BannerCreation" */ '@/components/banner/BannerCreation')
const BannerDetails = () =>
  import(/* webpackChunkName: "BannerDetails" */ '@/components/banner/BannerDetails')
const BannerList = () =>
  import(/* webpackChunkName: "BannerList" */ '@/components/banner/BannerList')
const BrandCreation = () =>
  import(/* webpackChunkName: "BrandCreation" */ '@/components/brand/BrandCreation')
const BrandDetails = () =>
  import(/* webpackChunkName: "BrandDetails" */ '@/components/brand/BrandDetails')
const BrandList = () => import(/* webpackChunkName: "BrandList" */ '@/components/brand/BrandList')
const BrandingReview = () =>
  import(/* webpackChunkName: "BrandingReview" */ '@/components/content/BrandingReview')
const IssueQueue = () =>
  import(/* webpackChunkName: "CallQueue" */ '@/components/device_issue/CallQueue')
const CampaignCreation = () =>
  import(/* webpackChunkName: "CampaignCreation" */ '@/components/campaign/CampaignCreation')
const CampaignManagement = () =>
  import(/* webpackChunkName: "CampaignManagement" */ '@/components/campaign2/CampaignManagement')
const CampaignDetails = () =>
  import(/* webpackChunkName: "CampaignDetails" */ '@/components/campaign/CampaignDetails')
const CampaignList = () =>
  import(/* webpackChunkName: "CampaignList" */ '@/components/campaign/CampaignList')
const CampaignReview = () =>
  import(/* webpackChunkName: "CampaignReview" */ '@/components/campaign/CampaignReview')
const Dashboard = () =>
  import(/* webpackChunkName: "Dashboard" */ '@/components/dashboard/Dashboard')
const DealCreation = () =>
  import(/* webpackChunkName: "DealCreation" */ '@/components/deal/DealCreation')
const DealDetails = () =>
  import(/* webpackChunkName: "DealDetails" */ '@/components/deal/DealDetails')
const DealSearch = () =>
  import(/* webpackChunkName: "DealSearch" */ '@/components/deal/DealSearch')
const DeviceDetails = () =>
  import(/* webpackChunkName: "DeviceDetails" */ '@/components/device/DeviceDetails')
const DeviceIssueCreation = () =>
  import(/* webpackChunkName: "DeviceIssueCreation" */ '@/components/device_issue/DeviceIssueCreation')
const DeviceIssueDetails = () =>
  import(/* webpackChunkName: "DeviceIssueDetails" */ '@/components/device_issue/DeviceIssueDetails')
const DeviceIssueList = () =>
  import(/* webpackChunkName: "DeviceIssueList" */ '@/components/device_issue/DeviceIssueList')
const DeviceList = () =>
  import(/* webpackChunkName: "DeviceList" */ '@/components/device/DeviceList')
const ExtAuditList = () =>
  import(/* webpackChunkName: "ExtAuditList" */ '@/components/ext_audit/ExtAuditList')
const ExtAuditListV2 = () =>
  import(/* webpackChunkName: "ExtAuditListV2" */ '@/components/ext_audit/ExtAuditListV2')
const ExtAuditTool = () =>
  import(/* webpackChunkName: "ExtAuditTool" */ '@/components/ext_audit/ExtAuditTool')
const ExtAuditLabeler = () =>
  import(/* webpackChunkName: "ExtAuditLabeler" */ '@/components/ext_audit/ExtAuditLabeler')
const ExtAuditImagesQueue = () =>
  import(/* webpackChunkName: "ExtAuditImagesQueue" */ '@/components/ext_audit/ExtAuditImagesQueue')
const ExtAuditSectionsQueue = () =>
  import(/* webpackChunkName: "ExtAuditSectionsQueue" */ '@/components/ext_audit/ExtAuditSectionsQueue')
const ExtAuditPlacementsQueue = () =>
  import(/* webpackChunkName: "ExtAuditPlacementsQueue" */ '@/components/ext_audit/ExtAuditPlacementsQueue')
const ExtAuditStickersQueue = () =>
  import(/* webpackChunkName: "ExtAuditStickersQueue" */ '@/components/ext_audit/ExtAuditStickersQueue')
const HotspotCreation = () =>
  import(/* webpackChunkName: "HotspotList" */ '@/components/hotspot/HotspotCreation')
const HotspotDetails = () =>
  import(/* webpackChunkName: "HotspotList" */ '@/components/hotspot/HotspotDetails')
const HotspotList = () =>
  import(/* webpackChunkName: "HotspotList" */ '@/components/hotspot/HotspotList')
const LastImpressionMetrics = () =>
  import(/* webpackChunkName: "LastImpressionMetrics" */ '@/components/metrics/LastImpressionMetrics')
const Login = () => import(/* webpackChunkName: "Login" */ '@/components/auth/Login')
const MarketingDashboard = () =>
  import(/* webpackChunkName: "MarketingDashboard" */ '@/components/marketing/MarketingDashboard')
const MarketingStoreList = () =>
  import(/* webpackChunkName: "MarketingStoreList" */ '@/components/marketing/MarketingStoreList')
const MerchandiseDashboard = () =>
  import(/* webpackChunkName: "MerchandiseDashboard" */ '@/components/merchandise/MerchandiseDashboard')
const MerchandiseProductList = () =>
  import(/* webpackChunkName: "MerchandiseProductList" */ '@/components/merchandise/MerchandiseProductList')
const MerchandiseStoreList = () =>
  import(/* webpackChunkName: "MerchandiseStoreList" */ '@/components/merchandise/MerchandiseStoreList')
const MerchandiseRetailerList = () =>
  import(/* webpackChunkName: "MerchandiseRetailerList" */ '@/components/merchandise/MerchandiseRetailerList')
const MultiFactorAuthenticationCheckpoint = () =>
  import(/* webpackChunkName: "MultiFactorAuthenticationCheckpoint" */ '@/components/auth/MultiFactorAuthenticationCheckpoint')
const MultiFactorAuthenticationEnroll = () =>
  import(/* webpackChunkName: "MultiFactorAuthenticationEnroll" */ '@/components/auth/MultiFactorAuthenticationEnroll')
const NotFound = () =>
  import(/* webpackChunkName: "NotFound" */ '@/components/common/NotFound')
const NotAuthorized = () =>
  import(/* webpackChunkName: "NotAuthorized" */ '@/components/common/NotAuthorized')
const PasswordReset = () =>
  import(/* webpackChunkName: "PasswordReset" */ '@/components/auth/PasswordReset')
const PogCreation = () =>
  import(/* webpackChunkName: "PogCreation" */ '@/components/pog/PogCreation')
const PogDetails = () => import(/* webpackChunkName: "PogDetails" */ '@/components/pog/PogDetails')
const PogList = () => import(/* webpackChunkName: "PogList" */ '@/components/pog/PogList')
const PogMapping = () => import(/* webpackChunkName: "PogMapping" */ '@/components/pog/PogMapping')
const PogMappingStoreList = () =>
  import(/* webpackChunkName: "PogMappingStoreList" */ '@/components/pog/PogMappingStoreList')
const PogMappingStoreDetails = () =>
  import(/* webpackChunkName: "PogMappingStoreDetails" */ '@/components/pog/PogMappingStoreDetails')
const ProductCreation = () =>
  import(/* webpackChunkName: "ProductCreation" */ '@/components/product/ProductCreation')
const ProductDetails = () =>
  import(/* webpackChunkName: "ProductDetails" */ '@/components/product/ProductDetails')
const ProductList = () =>
  import(/* webpackChunkName: "ProductList" */ '@/components/product/ProductList')
const ProductReview = () =>
  import(/* webpackChunkName: "ProductReview" */ '@/components/product/ProductReview')
const RetailerCreation = () =>
  import(/* webpackChunkName: "RetailerCreation" */ '@/components/retailer/RetailerCreation')
const RetailerDetails = () =>
  import(/* webpackChunkName: "RetailerDetails" */ '@/components/retailer/RetailerDetails')
const RetailerList = () =>
  import(/* webpackChunkName: "RetailerList" */ '@/components/retailer/RetailerList')
const SpringServeVideoList = () =>
  import(/* webpackChunkName: "SpringServeVideoList" */ '@/components/video/SpringServeVideoList')
const StockcheckMetrics = () =>
  import(/* webpackChunkName: "StockcheckMetrics" */ '@/components/metrics/StockcheckMetrics')
const StoreCreation = () =>
  import(/* webpackChunkName: "StoreCreation" */ '@/components/store/StoreCreation')
const StoreInstaller = () =>
  import(/* webpackChunkName: "StoreInstaller" */ '@/components/store/install/StoreInstaller')
const StoreDetails = () =>
  import(/* webpackChunkName: "StoreDetails" */ '@/components/store/StoreDetails')
const StoreList = () => import(/* webpackChunkName: "StoreList" */ '@/components/store/StoreList')
const StoreSearch = () =>
  import(/* webpackChunkName: "StoreSearch" */ '@/components/pricing/StoreSearch')
const UserCreation = () =>
  import(/* webpackChunkName: "UserCreation" */ '@/components/user/UserCreation')
const UserDetails = () =>
  import(/* webpackChunkName: "UserDetails" */ '@/components/user/UserDetails')
const UserList = () => import(/* webpackChunkName: "UserList" */ '@/components/user/UserList')
const UserSwitchInterstitial = () => import(/* webpackChunkName: "UserSwtichInterstitial" */ '@/components/user/UserSwitchInterstitial')
const VendorCreation = () =>
  import(/* webpackChunkName: "VendorCreation" */ '@/components/vendor/VendorCreation')
const VendorDetails = () =>
  import(/* webpackChunkName: "VendorDetails" */ '@/components/vendor/VendorDetails')
const VendorList = () =>
  import(/* webpackChunkName: "VendorList" */ '@/components/vendor/VendorList')
const VideoCreation = () =>
  import(/* webpackChunkName: "VideoCreation" */ '@/components/video/VideoCreation')
const VideoDetails = () =>
  import(/* webpackChunkName: "VideoDetails" */ '@/components/video/VideoDetails')
const VideoList = () => import(/* webpackChunkName: "VideoList" */ '@/components/video/VideoList')
const VideoReview = () =>
  import(/* webpackChunkName: "VideoReview" */ '@/components/video/VideoReview')
const WholesalerCreation = () =>
  import(/* webpackChunkName: "WholesalerCreation" */ '@/components/wholesaler/WholesalerCreation')
const WholesalerDetails = () =>
  import(/* webpackChunkName: "WholesalerDetails" */ '@/components/wholesaler/WholesalerDetails')
const WholesalerList = () =>
  import(/* webpackChunkName: "WholesalerList" */ '@/components/wholesaler/WholesalerList')

const AtmosphereBulkVideoUpload = () =>
  import(/* webpackChunkName: "AtmosphereBulkVideoUpload" */ '@/components/admin/AtmosphereBulkVideoUpload')

Vue.use(Router)

// TODO alphabetize routes by path rather than component (because order matters in this array)

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '*',
      redirect: '/not-found',
    },
    {
      component: AdvertiserCreation,
      name: 'AdvertiserCreation',
      path: '/advertiser/create',
      meta: {
        authRequired: true,
        pageName: 'Create Advertiser',
        layout: 'Sidebar',
      },
    },
    {
      component: AdvertiserDetails,
      name: 'AdvertiserDetails',
      path: '/advertiser/:id',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Advertiser',
        layout: 'Sidebar',
      },
    },
    {
      component: AdvertiserList,
      name: 'AdvertiserList',
      path: '/advertisers',
      meta: {
        authRequired: true,
        pageName: 'Advertiser List',
        layout: 'Sidebar',
      },
    },
    {
      component: AtmosphereBulkVideoUpload,
      name: 'AtmosphereBulkVideoUpload',
      path: '/admin/atmosphere',
      meta: {
        authRequired: true,
        pageName: 'AtmosphereBulkVideoUpload',
        layout: 'Sidebar',
      },
    },
    {
      component: AuditDetails,
      name: 'AuditDetails',
      path: '/audit/:id',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Audit',
        layout: 'Sidebar',
      },
    },
    {
      component: AuditList,
      name: 'AuditList',
      path: '/audits',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:stockcheck:audits',
        pageName: 'Audit List',
        layout: 'Sidebar',
      },
    },
    {
      component: AuditReview,
      name: 'AuditReview',
      path: '/audit/:id/review',
      props: true,
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: AuditReview,
      name: 'StoreIssuesReview',
      path: '/audit/:storesId/issues',
      props: true,
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: BannerCreation,
      name: 'BannerCreation',
      path: '/banner/create',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:banners',
        pageName: 'Create Banner',
        layout: 'Sidebar',
      },
    },
    {
      component: BannerDetails,
      name: 'BannerDetails',
      path: '/banner/:id',
      props: true,
      meta: {
        authRequired: true,
        requiredPermission: 'feature:banners',
        pageName: 'Banner',
        layout: 'Sidebar',
      },
    },
    {
      component: BannerList,
      name: 'BannerList',
      path: '/banners',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:banners',
        pageName: 'Banner List',
        layout: 'Sidebar',
      },
    },
    {
      component: BrandCreation,
      name: 'BrandCreation',
      path: '/brand/create',
      meta: {
        authRequired: true,
        pageName: 'Create Brand',
        layout: 'Sidebar',
      },
    },
    {
      component: BrandDetails,
      name: 'BrandDetails',
      path: '/brand/:id',
      props: true,
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: BrandList,
      name: 'BrandList',
      path: '/brands',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:products:brands',
        pageName: 'Brand List',
        layout: 'Sidebar',
      },
    },
    {
      component: BrandingReview,
      name: 'BrandingReview',
      path: '/review/branding',
      meta: {
        authRequired: true,
        pageName: 'Review Branding',
        layout: 'Sidebar',
      },
    },
    {
      component: IssueQueue,
      name: 'IssueQueue',
      path: '/issue-queue',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:devices:callQueue',
        pageName: 'Issue Queue',
        layout: 'Sidebar',
      },
    },
    {
      component: CampaignCreation,
      name: 'CampaignCreation',
      path: '/campaign/create',
      meta: {
        authRequired: true,
        pageName: 'Create Campaign',
        layout: 'Sidebar',
      },
    },
    {
      component: CampaignManagement,
      name: 'CampaignManagement',
      path: '/campaign/:id/manage',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Create Management',
        layout: 'Sidebar',
      },
    },
    {
      component: CampaignDetails,
      name: 'CampaignDetails',
      path: '/campaign/:id',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Campaign',
        layout: 'Sidebar',
      },
    },
    {
      component: CampaignList,
      name: 'CampaignList',
      path: '/campaigns',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:marketing:campaigns',
        pageName: 'Campaign List',
        layout: 'Sidebar',
      },
    },
    {
      component: CampaignReview,
      name: 'CampaignReview',
      path: '/review/campaign',
      meta: {
        authRequired: true,
        pageName: 'Review Campaigns',
        layout: 'Sidebar',
      },
    },
    {
      component: Dashboard,
      name: 'Dashboard',
      path: '/',
      meta: {
        authRequired: true,
        pageName: 'Dashboard',
        layout: 'Sidebar',
      },
    },
    {
      component: DealCreation,
      name: 'DealCreation',
      path: '/deals/create',
      meta: {
        authRequired: true,
        pageName: 'Create Deal',
        layout: 'Sidebar',
      },
    },
    {
      component: DealDetails,
      name: 'DealDetails',
      path: '/deals/:id/',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Deal',
        layout: 'Sidebar',
      },
    },
    {
      component: DealSearch,
      name: 'DealSearch',
      path: '/deals',
      meta: {
        authRequired: true,
        pageName: 'Deal Search',
        layout: 'Sidebar',
      },
    },
    {
      component: DeviceDetails,
      name: 'DeviceDetails',
      path: '/device/:id',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Device',
        layout: 'Sidebar',
      },
    },
    {
      component: DeviceIssueCreation,
      name: 'DeviceIssueCreation',
      path: '/device-issue/create',
      meta: {
        authRequired: true,
        pageName: 'Create Device Issue',
        layout: 'Sidebar',
      },
    },
    {
      component: DeviceIssueDetails,
      name: 'DeviceIssueDetails',
      path: '/device-issue/:id',
      props: true,
      meta: {
        authRequired: true,
        requiredPermission: 'feature:devices:issue',
        pageName: 'Device Issue',
        layout: 'Sidebar',
      },
    },
    {
      component: DeviceIssueList,
      name: 'DeviceIssueList',
      path: '/device-issues',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:devices:issues',
        pageName: 'Device Issue List',
        layout: 'Sidebar',
      },
    },
    {
      component: DeviceList,
      name: 'DeviceList',
      path: '/devices',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:devices:devices',
        pageName: 'Device List',
        layout: 'Sidebar',
      },
    },
    {
      component: ExtAuditList,
      name: 'ExtAuditList',
      path: '/extAudits',
      meta: {
        authRequired: true,
        pageName: 'Mobile Audit List',
        layout: 'Sidebar',
      },
    },
    {
      component: ExtAuditListV2,
      name: 'ExtAuditListV2',
      path: '/extAudits2',
      meta: {
        authRequired: true,
        pageName: 'Mobile Audit List V2',
        layout: 'Sidebar',
      },
    },
    {
      component: ExtAuditTool,
      name: 'ExtAuditTool',
      path: '/extAudits/tool',
      meta: {
        authRequired: true,
        pageName: 'Mobile Audit Tool',
        layout: 'Sidebar',
      },
    },
    {
      component: ExtAuditTool,
      name: 'ExtAuditToolEditor',
      path: '/extAudits/tool/:id',
      meta: {
        authRequired: true,
        pageName: 'Mobile Audit Tool',
        layout: 'Sidebar',
      },
    },
    {
      component: ExtAuditLabeler,
      name: 'ExtAuditLabeler',
      path: '/extAudits/labeler',
      meta: {
        authRequired: true,
        pageName: 'Image Labeling Tool',
        layout: 'Basic',
      },
    },
    {
      component: ExtAuditImagesQueue,
      name: 'ExtAuditImagesQueue',
      path: '/extAudits/images-queue/:imgId',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'ExtAudit Images Queue',
        layout: 'Sidebar',
      },
    },
    {
      component: ExtAuditSectionsQueue,
      name: 'ExtAuditSectionsQueue',
      path: '/extAudits/sections-queue/:imgId/:sectionNumber',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'ExtAudit Sections Queue',
        layout: 'Sidebar',
      },
    },
    {
      component: ExtAuditPlacementsQueue,
      name: 'ExtAuditPlacementsQueue',
      path: '/extAudits/placements-queue/:imgId/:sectionNumber',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'ExtAudit Placements Queue',
        layout: 'Sidebar',
      },
    },
    {
      component: ExtAuditStickersQueue,
      name: 'ExtAuditStickersQueue',
      path: '/extAudits/stickers-queue/:imgId/:sectionNumber/:placementNumber',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'ExtAudit Stickers Queue',
        layout: 'Sidebar',
      },
    },
    {
      component: HotspotCreation,
      name: 'HotspotCreation',
      path: '/hotspot/create',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Create Hotspot',
        layout: 'Sidebar',
      },
    },
    {
      component: HotspotDetails,
      name: 'HotspotDetails',
      path: '/hotspot/:id?',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Hotspot',
        layout: 'Sidebar',
      },
    },
    {
      component: HotspotList,
      name: 'HotspotList',
      path: '/hotspots',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Hotspot List',
        layout: 'Sidebar',
      },
    },
    {
      component: LastImpressionMetrics,
      name: 'LastImpressionMetrics',
      path: '/metrics/advertising',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:advertising:metrics',
        layout: 'Sidebar',
      },
    },
    {
      component: Login,
      name: 'Login',
      path: '/login',
      meta: {
        authRequired: false,
        layout: 'Basic',
      },
    },
    {
      component: MarketingDashboard,
      name: 'Marketing',
      path: '/marketing',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:marketing:dashboard',
        pageName: 'Marketing Dashboard',
        layout: 'Sidebar',
      },
    },
    {
      component: MarketingStoreList,
      name: 'MarketingStoreList',
      path: '/marketing/stores',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:marketing:stores',
        pageName: 'Marketing Store List',
        layout: 'Sidebar',
      },
    },
    {
      component: MerchandiseDashboard,
      name: 'Merchandise',
      path: '/merchandise',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:merchandise:dashboard',
        pageName: 'Merchandise Dashboard',
        layout: 'Sidebar',
      },
    },
    {
      component: MerchandiseStoreList,
      name: 'MerchandiseStoreList',
      path: '/merchandise/stores',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:merchandise:stores',
        pageName: 'Merchandise Store List',
        layout: 'Sidebar',
      },
    },
    {
      component: MerchandiseRetailerList,
      name: 'MerchandiseRetailerList',
      path: '/merchandise/retailers',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:merchandise:retailers',
        pageName: 'Merchandise Retailer List',
        layout: 'Sidebar',
      },
    },
    {
      component: MerchandiseProductList,
      name: 'MerchandiseProductList',
      path: '/merchandise/products',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:merchandise:products',
        pageName: 'Merchandise Product List',
        layout: 'Sidebar',
      },
    },
    {
      component: MultiFactorAuthenticationEnroll,
      name: 'MultiFactorAuthenticationEnroll',
      path: '/mfa/enroll',
      meta: {
        authRequired: false,
        layout: 'Basic',
      },
    },
    {
      component: MultiFactorAuthenticationCheckpoint,
      name: 'MultiFactorAuthenticationCheckpoint',
      path: '/mfa/checkpoint',
      meta: {
        authRequired: false,
        layout: 'Basic',
      },
    },
    {
      component: NotFound,
      name: 'NotFound',
      path: '/not-found',
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: NotAuthorized,
      name: 'NotAuthorized',
      path: '/not-authorized',
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: PogCreation,
      name: 'PogCreation',
      path: '/pog/create',
      meta: {
        authRequired: true,
        pageName: 'Create Planogram',
        layout: 'Sidebar',
      },
    },
    {
      component: PogDetails,
      name: 'PogDetails',
      path: '/pog/:id',
      props: true,
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: PogList,
      name: 'PogList',
      path: '/pogs',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:stockcheck:planograms',
        pageName: 'Planogram List',
        layout: 'Sidebar',
      },
    },
    {
      component: PogMapping,
      name: 'PogMapping',
      path: '/pogs/map',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:stockcheck:mapping',
        layout: 'Sidebar',
      },
    },
    {
      component: PogMappingStoreList,
      name: 'PogMappingStoreList',
      path: '/pogs/stores',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:stockcheck:mapping',
        layout: 'Sidebar',
      },
    },
    {
      component: PogMappingStoreDetails,
      name: 'PogMappingStoreDetails',
      path: '/pogs/store/:id',
      props: true,
      meta: {
        authRequired: true,
        requiredPermission: 'feature:stockcheck:mapping',
        layout: 'Sidebar',
      },
    },
    {
      component: PasswordReset,
      name: 'PasswordReset',
      path: '/reset',
      meta: {
        authRequired: false,
        layout: 'Basic',
      },
    },
    {
      component: ProductCreation,
      name: 'ProductCreation',
      path: '/product/create',
      meta: {
        authRequired: true,
        pageName: 'Create Product',
        layout: 'Sidebar',
      },
    },
    {
      component: ProductDetails,
      name: 'ProductDetails',
      path: '/product/:id',
      props: true,
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: ProductList,
      name: 'ProductList',
      path: '/products',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:products:products',
        pageName: 'Product List',
        layout: 'Sidebar',
      },
    },
    {
      component: ProductReview,
      name: 'ProductReview',
      path: '/products/verify',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:products:verify',
        layout: 'Sidebar',
      },
    },
    {
      component: CampaignList,
      name: 'PromotionList',
      path: '/promotions',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:marketing:campaigns',
        pageName: 'Promotion List',
        layout: 'Sidebar',
      },
    },
    {
      component: CampaignDetails,
      name: 'PromotionDetails',
      path: '/promotion/:id',
      props: true,
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: RetailerCreation,
      name: 'RetailerCreation',
      path: '/retailer/create',
      meta: {
        authRequired: true,
        pageName: 'Create Retailer',
        layout: 'Sidebar',
      },
    },
    {
      component: RetailerDetails,
      name: 'RetailerDetails',
      path: '/retailer/:id',
      props: true,
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: RetailerList,
      name: 'RetailerList',
      path: '/retailers',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:retailers',
        pageName: 'Retailer List',
        layout: 'Sidebar',
      },
    },
    {
      component: SpringServeVideoList,
      name: 'SpringServeVideoList',
      path: '/video/springservevideos',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:springserve',
        pageName: 'SpringServe Video List',
        layout: 'Sidebar',
      },
    },
    {
      component: StockcheckMetrics,
      name: 'StockcheckMetrics',
      path: '/metrics/stockcheck',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:stockcheck:metrics',
        layout: 'Sidebar',
      },
    },
    {
      component: StoreCreation,
      name: 'StoreCreation',
      path: '/store/create',
      meta: {
        authRequired: true,
        pageName: 'Create Store',
        layout: 'Sidebar',
      },
    },
    {
      component: StoreInstaller,
      name: 'StoreInstaller',
      path: '/store/install/:id/:urlStepIdx?',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Store Installer',
        layout: 'Sidebar',
      },
    },
    {
      component: StoreDetails,
      name: 'StoreDetails',
      path: '/store/:id/:view?',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Store',
        layout: 'Sidebar',
      },
    },
    {
      component: StoreList,
      name: 'StoreList',
      path: '/stores',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:stores:stores',
        pageName: 'Store List',
        layout: 'Sidebar',
      },
    },
    {
      component: StoreSearch,
      name: 'StoreSearch',
      path: '/pricing/stores',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:pricing:store_search',
        pageName: 'Store Search',
        layout: 'Sidebar',
      },
    },
    {
      component: UserCreation,
      name: 'UserCreation',
      path: '/user/create',
      meta: {
        authRequired: true,
        pageName: 'Create User',
        layout: 'Sidebar',
      },
    },
    {
      component: UserDetails,
      name: 'UserDetails',
      path: '/user/:id',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'User',
        layout: 'Sidebar',
      },
    },
    {
      component: UserList,
      name: 'UserList',
      path: '/users',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:users:users',
        pageName: 'User List',
        layout: 'Sidebar',
      },
    },
    {
      component: UserSwitchInterstitial,
      name: 'UserSwitchInterstitial',
      path: '/switch',
      meta: {
        authRequired: true,
        layout: 'Empty',
      },
    },
    {
      component: VendorCreation,
      name: 'VendorCreation',
      path: '/vendor/create',
      meta: {
        authRequired: true,
        pageName: 'Create Vendor',
        layout: 'Sidebar',
      },
    },
    {
      component: VendorDetails,
      name: 'VendorDetails',
      path: '/vendor/:id',
      props: true,
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: VendorList,
      name: 'VendorList',
      path: '/vendors',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:products:vendors',
        pageName: 'Vendor List',
        layout: 'Sidebar',
      },
    },
    {
      component: VideoCreation,
      name: 'VideoCreation',
      path: '/video/create',
      meta: {
        authRequired: true,
        pageName: 'Create Video',
        layout: 'Sidebar',
      },
    },
    {
      component: VideoDetails,
      name: 'VideoDetails',
      path: '/video/:id',
      props: true,
      meta: {
        authRequired: true,
        pageName: 'Video',
        layout: 'Sidebar',
      },
    },
    {
      component: VideoList,
      name: 'VideoList',
      path: '/videos',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:marketing:videos',
        pageName: 'Video List',
        layout: 'Sidebar',
      },
    },
    {
      component: VideoReview,
      name: 'VideoReview',
      path: '/review/video',
      meta: {
        authRequired: true,
        pageName: 'Review Videos',
        layout: 'Sidebar',
      },
    },
    {
      component: WholesalerCreation,
      name: 'WholesalerCreation',
      path: '/wholesaler/create',
      meta: {
        authRequired: true,
        pageName: 'Create Wholesaler',
        layout: 'Sidebar',
      },
    },
    {
      component: WholesalerDetails,
      name: 'WholesalerDetails',
      path: '/wholesaler/:id',
      props: true,
      meta: {
        authRequired: true,
        layout: 'Sidebar',
      },
    },
    {
      component: WholesalerList,
      name: 'WholesalerList',
      path: '/wholesalers',
      meta: {
        authRequired: true,
        requiredPermission: 'feature:stores:wholesalers',
        pageName: 'Wholesaler List',
        layout: 'Sidebar',
      },
    },
  ],
})

router.afterEach((to, from) => {
  if (store.getters['Auth/authenticated']) {
    // Run after DOM updates and component queries
    Vue.nextTick(() => {
      setTimeout(() => {
        apollo.defaultClient.mutate({
          mutation: ChangeFrontendPage,
          variables: {
            pageChange: {
              newPage: to.path,
              oldPage: from.path,
            },
          },
        })
      }, 1500)
    })
  }
})

router.beforeEach((to, from, next) => {
  /**
   * Important Note:
   *
   * Since router includes store, it's adviseable
   * to avoid importing router in any modules to use
   * for common redirects. A circular import could cause
   * store to be undefined, causing the router guard to
   * fail and the application to stop loading completely.
   */

  // Check validity of authentication session, remove if expired
  store.dispatch('Auth/checkExpiration').then(() => {
    // Prevent MFA users from navigating anywhere but MFA checkpoint
    if (to.path !== '/mfa/checkpoint' && store.getters['Auth/mfaPending']) {
      log.debug('User is awaiting multi-factor authentication. Redirecting to checkpoint')
      return next({ path: '/mfa/checkpoint' })
    }

    // Prevent MFA enrollment users from navigating anywhere but MFA enrollment
    if (to.path !== '/mfa/enroll' && store.getters['Auth/mfaEnroll']) {
      log.debug('User is awaiting multi-factor enrollment. Redirecting to enrollment')
      return next({ path: '/mfa/enroll' })
    }

    // Don't let an authenticated user navigate to login.
    // If they do, redirect to the dashboard
    if (to.path === '/login' && store.getters['Auth/authenticated']) {
      log.debug('User is already logged in. Redirecting to dashboard')
      return next({ path: '/' })
    }

    // Is the user authenticated?
    if (to.meta.authRequired && !store.getters['Auth/authenticated']) {
      log.debug('Authentication required for this route. Redirecting to login')
      Message.closeAll()
      return next({ path: '/login', query: { redirect: to.path } })
    }

    // Check that a user has given permission before navigating
    if (to.meta.requiredPermission && !store.getters['Auth/hasPermission'](to.meta.requiredPermission)) {
      // TODO: Add a 404 page
      log.debug('Permission requirement not met for this route. Redirecting to dashboard home')
      return next({ path: '/not-authorized' })
    }

    // Redirect users who don't have dashboard access ('/')
    if (to.path === '/') {
      let redirect = from.query.redirect || undefined
      // Override the to path if it points to the dashboard
      if (redirect === '%2F' || redirect === '/') {
        redirect = undefined
      }
      // Advertiser users go to marketing dashboard
      if (store.getters['Auth/user'].roles.includes('Advertiser')) {
        log.debug('Advertising does not have dashboard access, redirecting to /marketing or redirect path')
        return next({ path: from.query.redirect || '/marketing' })
      }
      // Retailer Merchandiser users go to merchandise dashboard
      if ((store.getters['Auth/user'].roles.includes('Retailer')
        || store.getters['Auth/user'].roles.includes('Wholesaler'))
      && !store.getters['Auth/user'].roles.includes('Advertising')) {
      // eslint-disable-next-line max-len
        log.debug('Retail Merchandiser does not have dashboard access, redirecting to /merchandise or redirect path')
        return next({ path: from.query.redirect || '/merchandise' })
      }
      // Stockcheck admin goes to /audits
      if (store.getters['Auth/user'].roles.includes('Stockcheck Admin')) {
        log.debug('Redirecting Stockcheck Admin to /audits or redirect path')
        return next({ path: from.query.redirect || '/audits' })
      }
      // IT admin goes to devices
      if (store.getters['Auth/user'].roles.length === 1 && store.getters['Auth/user'].roles.includes('IT')) {
        log.debug('Redirecting IT user to /devices or redirect path')
        return next({ path: from.query.redirect || '/devices' })
      }
      // Call Contractors go to call queue
      if (store.getters['Auth/user'].roles.includes('Call Contractor')) {
        log.debug('Redireting Call Contractor to /issue-queue')
        return next({ path: from.query.redirect || '/issue-queue' })
      }
      // Device Install Contractors and Network Health Contractors goes to stores
      if (store.getters['Auth/user'].roles.length === 1 &&
        (store.getters['Auth/user'].roles.includes('Device Install Contractor') ||
          store.getters['Auth/user'].roles.includes('Network Health Contractor'))) {
        log.debug('Redirecting Device Install Contractor to /stores or redirect path')
        return next({ path: from.query.redirect || '/stores' })
      }
    }

    return next()
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js